export var DEFAULT_NOTIFICATION_VARIANT = 'secondary';